/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Lead_DescInputs */

const en_cp_p_lead_desc = /** @type {(inputs: Cp_P_Lead_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 student leads per campus: free Campus seat for an academic year, club credits, build-night kit, tiers Perintis → Penggerak → Pelopor.`)
};

const id_cp_p_lead_desc = /** @type {(inputs: Cp_P_Lead_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–2 mahasiswa penggerak per kampus: kursi Kampus gratis 1 tahun akademik, kredit klub, kit build night, tier Perintis → Penggerak → Pelopor.`)
};

/**
* | output |
* | --- |
* | "1–2 student leads per campus: free Campus seat for an academic year, club credits, build-night kit, tiers Perintis → Penggerak → Pelopor." |
*
* @param {Cp_P_Lead_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_lead_desc = /** @type {((inputs?: Cp_P_Lead_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Lead_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_lead_desc(inputs)
	return en_cp_p_lead_desc(inputs)
});